(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lua-co-featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lua-featured-product')) {
    customElements.define('lua-featured-product', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        try { this.data = JSON.parse(this.querySelector('[data-product-data]').textContent); } catch (_) { this.data = {}; }
        this.variants = Array.isArray(this.data.variants) ? this.data.variants : [];
        this.form = this.querySelector('form');
        this.nameInput = this.querySelector('[data-personalization-name]');
        this.variantInput = this.querySelector('[data-variant-id]');
        this.submit = this.querySelector('[data-product-submit]');
        this.submitLabel = this.querySelector('[data-submit-label]');
        this.message = this.querySelector('[data-product-message]');
        this.addEventListener('click', event => {
          const thumbnail = event.target.closest('[data-gallery-choice]');
          if (thumbnail && this.contains(thumbnail)) this.showGallery(thumbnail.dataset.galleryChoice);
        }, { signal });
        this.addEventListener('change', event => {
          if (event.target.matches('[data-option-position]')) this.updateVariant(true);
          if (event.target.matches('[data-preview-color]')) {
            const text = this.querySelector('[data-selected-color]');
            if (text) text.textContent = event.target.value;
          }
        }, { signal });
        if (this.nameInput) this.nameInput.addEventListener('input', () => this.nameInput.setCustomValidity(''), { signal });
        if (this.form) this.form.addEventListener('submit', event => {
          if (this.dataset.canPurchase !== 'true') { event.preventDefault(); return; }
          this.updateVariant(false);
          this.nameInput.value = this.nameInput.value.trim();
          this.nameInput.setCustomValidity(this.nameInput.value ? '' : 'Please enter the last name for your topper.');
          if (!this.form.checkValidity() || !this.currentVariant || !this.currentVariant.available) {
            event.preventDefault(); this.form.reportValidity(); return;
          }
          this.submit.disabled = true;
          this.submitLabel.textContent = 'Adding to cart…';
        }, { signal });
        window.addEventListener('pageshow', () => this.updateVariant(false), { signal });
        this.updateVariant(false);
      }
      disconnectedCallback() { if (this.controller) this.controller.abort(); }
      selectedOptions() {
        const values = [];
        this.querySelectorAll('[data-option-position]').forEach(input => {
          if (input.type !== 'radio' || input.checked) values[Number(input.dataset.optionPosition)-1] = input.value;
        });
        return values;
      }
      updateVariant(updatePhoto) {
        if (this.dataset.canPurchase !== 'true') return;
        const options = this.selectedOptions();
        const variant = options.length ? this.variants.find(item => item.options.length === options.length && item.options.every((value,index) => value === options[index])) : this.variants[0];
        this.currentVariant = variant || null;
        if (this.variantInput) this.variantInput.value = variant ? variant.id : '';
        const available = Boolean(variant && variant.available);
        if (this.submit) this.submit.disabled = !available;
        if (this.submitLabel) this.submitLabel.textContent = !variant ? 'Unavailable combination' : available ? (this.data.buttonLabel || 'Personalize yours') : 'Sold out';
        if (this.message) this.message.textContent = !variant ? 'This combination is not available. Please choose another option.' : available ? '' : 'This option is currently sold out.';
        const selectedColor = this.querySelector('[data-color-option]:checked');
        const colorText = this.querySelector('[data-selected-color]');
        if (selectedColor && colorText) colorText.textContent = selectedColor.value;
        const price = this.querySelector('[data-variant-price]');
        if (price && variant) {
          try { price.textContent = new Intl.NumberFormat(this.data.locale || 'en-US', { style:'currency', currency:this.data.currency || 'USD' }).format(variant.price/100); } catch (_) {}
        }
        this.querySelectorAll('[data-color-option]').forEach(input => {
          const position = Number(input.dataset.optionPosition)-1;
          const possible = this.variants.some(item => item.available && item.options.every((value,index) => value === (index === position ? input.value : options[index])));
          input.closest('.lfp-color').dataset.unavailable = String(!possible);
        });
        if (updatePhoto && variant && variant.featured_image && variant.featured_image.src) this.showVariantImage(variant.featured_image);
      }
      showGallery(id) {
        this.querySelectorAll('[data-gallery-image]').forEach(item => { item.hidden = item.dataset.galleryImage !== id; });
        const variantWrap = this.querySelector('[data-variant-image-wrap]');
        if (variantWrap) variantWrap.hidden = true;
        this.querySelectorAll('[data-gallery-choice]').forEach(item => item.setAttribute('aria-pressed',String(item.dataset.galleryChoice === id)));
        const visible = this.querySelector('[data-gallery-image]:not([hidden]) img');
        if (visible) visible.loading = 'eager';
        const status = this.querySelector('[data-gallery-status]');
        if (status) status.textContent = 'Product photograph '+id+' displayed.';
      }
      showVariantImage(image) {
        const wrap = this.querySelector('[data-variant-image-wrap]');
        if (!wrap) return;
        let img = wrap.querySelector('img');
        if (!img) { img = document.createElement('img'); img.className = 'lfp-image'; wrap.appendChild(img); }
        img.src = image.src;
        img.alt = image.alt || 'Selected product variant';
        img.width = image.width || 1600; img.height = image.height || 1600;
        this.querySelectorAll('[data-gallery-image]').forEach(item => { item.hidden = true; });
        wrap.hidden = false;
        this.querySelectorAll('[data-gallery-choice]').forEach(item => item.setAttribute('aria-pressed','false'));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lua-co-finishes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lua-finish-switcher')) {
    customElements.define('lua-finish-switcher', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.choices = Array.from(this.querySelectorAll('[data-finish-id]'));
        this.panels = Array.from(this.querySelectorAll('[data-finish-panel]'));
        this.overview = this.querySelector('[data-finish-overview]');
        this.status = this.querySelector('.lcf-status');
        this.addEventListener('click', event => {
          const choice = event.target.closest('[data-finish-id]');
          if (choice && this.contains(choice)) this.selectFinish(choice.dataset.finishId);
          const example = event.target.closest('[data-finish-example]');
          if (example && this.contains(example)) this.selectExample(example);
        }, { signal });
        this.addEventListener('keydown', event => {
          const choice = event.target.closest('[data-finish-id]');
          if (!choice || !this.choices.includes(choice)) return;
          const index = this.choices.indexOf(choice);
          let nextIndex;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % this.choices.length;
          else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + this.choices.length) % this.choices.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = this.choices.length - 1;
          else return;
          event.preventDefault();
          const nextChoice = this.choices[nextIndex];
          nextChoice.focus();
          this.selectFinish(nextChoice.dataset.finishId);
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const selectedId = String(event.detail && event.detail.blockId || '');
          if (this.choices.some(choice => choice.dataset.finishId === selectedId)) this.selectFinish(selectedId, false);
        }, { signal });
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
      }

      selectFinish(id, announce = true) {
        const panel = this.panels.find(item => item.dataset.finishPanel === id);
        const selectedChoice = this.choices.find(item => item.dataset.finishId === id);
        if (!panel || !selectedChoice) return;
        if (this.overview) this.overview.hidden = true;
        this.panels.forEach(item => { item.hidden = item !== panel; });
        this.choices.forEach(item => { item.setAttribute('aria-pressed', String(item === selectedChoice)); });
        const shownImage = panel.querySelector('[data-finish-image]:not([hidden]) img');
        if (shownImage) shownImage.loading = 'eager';
        if (announce && this.status) {
          const count = panel.querySelectorAll('[data-finish-image]').length;
          this.status.textContent = selectedChoice.dataset.finishTitle + ' selected. ' +
            (count ? count + (count === 1 ? ' example available.' : ' examples available. Choose a thumbnail to view each one.') : 'Add example images in the theme editor.');
        }
      }

      selectExample(option) {
        const panel = option.closest('[data-finish-panel]');
        if (!panel) return;
        const exampleId = option.dataset.finishExample;
        const images = Array.from(panel.querySelectorAll('[data-finish-image]'));
        images.forEach(item => {
          item.hidden = item.dataset.finishImage !== exampleId;
          if (!item.hidden) {
            const image = item.querySelector('img');
            if (image) image.loading = 'eager';
          }
        });
        panel.querySelectorAll('[data-finish-example]').forEach(item => { item.setAttribute('aria-pressed', String(item === option)); });
        const caption = panel.querySelector('[data-example-caption]');
        if (caption) caption.textContent = option.dataset.exampleLabel;
        if (this.status) this.status.textContent = option.dataset.exampleLabel + ' displayed.';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lua-co-instagram-reels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lua-instagram-reels')) {
    customElements.define('lua-instagram-reels', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-play-reel]');
          if (!button || !this.contains(button)) return;
          const card = button.closest('[data-reel-card]');
          const player = card.querySelector('[data-reel-player]');
          const video = player && player.querySelector('video');
          const cover = card.querySelector('[data-reel-cover]');
          const status = card.querySelector('[data-reel-status]');
          if (!video || !cover) return;
          this.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
          player.hidden = false;
          cover.hidden = true;
          card.classList.add('is-playing');
          video.controls = true;
          video.focus();
          if (status) status.textContent = '';
          const playRequest = video.play();
          if (playRequest && typeof playRequest.catch === 'function') playRequest.catch(() => {
            if (status) status.textContent = 'Use the video controls to start playback, or open the Reel on Instagram.';
          });
        }, { signal });
        this.querySelectorAll('video').forEach(video => {
          video.setAttribute('tabindex','0');
          video.addEventListener('error', () => {
            const card = video.closest('[data-reel-card]');
            const player = card.querySelector('[data-reel-player]');
            const cover = card.querySelector('[data-reel-cover]');
            player.hidden = true;
            cover.hidden = false;
            card.classList.remove('is-playing');
            const status = card.querySelector('[data-reel-status]');
            if (status) status.textContent = 'This video could not be loaded. Please try again or open the Reel on Instagram.';
          }, { signal });
        });
      }
      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        this.querySelectorAll('video').forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lua-co-product-media"] && !Shopify.designMode) return;
  try {
    
(() => {
  class LuaProductMediaGallery extends HTMLElement {
    connectedCallback() {
      if (this.abort || this.initFrame) return;
      this.initFrame = requestAnimationFrame(() => {
        this.initFrame = null;
        if (this.isConnected) this.initialize();
      });
    }
    initialize() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.panels = [...this.querySelectorAll('[data-lua-pm-panel]')];
      this.buttons = [...this.querySelectorAll('[data-lua-pm-thumb]')];
      const strip = this.querySelector('.lua-pm-thumbnails');
      if (strip && this.buttons.length > 1) strip.hidden = false;
      const options = {signal: this.abort.signal};
      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => this.select(index), options);
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.buttons.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.buttons.length) % this.buttons.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.buttons.length - 1;
          else return;
          event.preventDefault(); this.select(next); this.buttons[next].focus({preventScroll: true});
          this.buttons[next].scrollIntoView({block: 'nearest', inline: 'nearest', behavior: 'instant'});
        }, options);
      });
    }
    select(index) {
      if (!this.panels[index]) return;
      this.panels.forEach((panel, i) => panel.hidden = i !== index);
      this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      const status = this.querySelector('[data-lua-pm-status]');
      if (status) status.textContent = `Image ${index + 1} of ${this.panels.length}`;
      this.dataset.selectedImage = String(index);
    }
    disconnectedCallback() {
      if (this.initFrame) cancelAnimationFrame(this.initFrame);
      this.initFrame = null;
      this.abort?.abort(); this.abort = null;
    }
  }
  class LuaProductReel extends HTMLElement {
    connectedCallback() {
      if (this.controller || this.initFrame) return;
      this.initFrame = requestAnimationFrame(() => {
        this.initFrame = null;
        if (this.isConnected) this.initialize();
      });
    }
    initialize() {
      if (this.controller) return;
      const video = this.querySelector('video');
      const cover = this.querySelector('[data-lua-reel-cover]');
      const play = this.querySelector('[data-lua-reel-play]');
      const status = this.querySelector('[data-lua-reel-status]');
      if (!video || !cover || !play) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      video.controls = true;
      video.setAttribute('tabindex', '0');
      const showControls = message => {
        cover.hidden = true;
        video.controls = true;
        if (status) status.textContent = message;
      };
      cover.hidden = video.error != null || !video.paused;
      play.addEventListener('click', () => {
        if (status) status.textContent = '';
        cover.hidden = true;
        video.controls = true;
        video.focus({preventScroll: true});
        if (video.ended) video.currentTime = 0;
        try {
          const result = video.play();
          if (result?.catch) result.catch(() => {
            if (!this.isConnected) return;
            showControls('Please use the video controls to start playback.');
          });
        } catch {
          showControls('Please use the video controls to start playback.');
        }
      }, options);
      video.addEventListener('play', () => {
        cover.hidden = true;
        if (status) status.textContent = '';
      }, options);
      video.addEventListener('ended', () => {
        cover.hidden = false;
        if (status) status.textContent = '';
      }, options);
      video.addEventListener('error', () => {
        showControls('This video could not be loaded. Please refresh the page and try again.');
      }, options);
    }
    disconnectedCallback() {
      if (this.initFrame) cancelAnimationFrame(this.initFrame);
      this.initFrame = null;
      this.controller?.abort();
      this.controller = null;
      this.querySelector('video')?.pause();
    }
  }
  if (!customElements.get('lua-product-media-gallery')) customElements.define('lua-product-media-gallery', LuaProductMediaGallery);
  if (!customElements.get('lua-product-reel')) customElements.define('lua-product-reel', LuaProductReel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lua-co-product-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-lua-review-open]');
    if (!link) return;
    const panel = document.getElementById(link.dataset.luaReviewOpen);
    if (!(panel instanceof HTMLDetailsElement)) return;
    panel.open = true;
    const nameField = panel.querySelector('input[name="contact[name]"]');
    const status = panel.querySelector('[role="status"], [role="alert"]');
    requestAnimationFrame(function () {
      const target = status || nameField;
      if (target && target.isConnected) target.focus({ preventScroll: true });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
